import React from "react";
import { Translate } from 'react-redux-i18n';
import SpinnerButton from './SpinnerButton';
import NotificationSystem from 'react-notification-system';


class TuiEditor extends React.Component {
  editor = null
  _notificationSystem = null
  componentDidMount() {
    const Editor = window.toastui.Editor;
    const { colorSyntax } = Editor.plugin;
    this.editor = new Editor({
      el: document.querySelector('#tui-editor'),
      height: '400px',
      initialValue: this.props.htmlString,
      initialEditType: 'wysiwyg',
      previewStyle: 'tab',
      customHTMLSanitizer: html => html,
      change: () => {

      },
      plugins: [colorSyntax]
    });
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillUnmount() {
    if(this.editor !== null) {
      this.editor.destroy();
      this.editor = null;
    }

  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.saveSuccess && nextProps.saveSuccess !== this.props.saveSuccess) {
      this.handleAddNotification('save_successful', 'success');
    }
  }

  handleAddNotification = (title, level) => {
    this.refs.notificationSystem.addNotification({
      title: <Translate value={title} />,
      level,
    });
  }

  handleSave = () => {
    this.props.saveHtml(this.editor.getHTML());
  }

  render() {
    const style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
        },
        success: { // Applied only to the success notification item
          color: 'red',
        },
      },
    };
    return <div id="tui-text-editor">
      <div id="tui-editor"></div>
      <SpinnerButton
        bsStyle="success"
        className={'save-button-right'}
        onClick={this.handleSave}
        disabled={this.props.isLoadingSave}
        loading={this.props.isLoadingSave}
        icon="fa-save"
        translation={<Translate value="save" />}
      />
      <NotificationSystem ref="notificationSystem" style={style} />
    </div>
  }
}

export default TuiEditor



// WEBPACK FOOTER //
// ./master/jsx/components/Common/TuiEditor.jsx